import React, { useState, useEffect, useRef, useContext } from 'react';
import { useReactToPrint } from "react-to-print";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ReactToPrint from "react-to-print";

function Invoice({ AcAddress1, AcAddress2, tableData, AcHead, ItemMaster, showPDFComponent, flag, CompCode, CompName }) {

    const componentRef = useRef();
    const [isPrinted, setIsPrinted] = useState(false);
    const [dataReady, setDataReady] = useState(false);
    const hasTableData = Array.isArray(tableData) && tableData.length > 0;
    //console.log("Saved Data :", tableData, hasTableData);

    useEffect(() => {
        if (hasTableData && !dataReady) {
            setDataReady(true);
        }
    }, [tableData, dataReady, hasTableData]);

    useEffect(() => {
        if (showPDFComponent && dataReady && !isPrinted) {
            handlePrint();
        }
    }, [showPDFComponent, dataReady, isPrinted]);

    /* const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Invoice",
        onAfterPrint: () => {
            setIsPrinted(true);
        },
        pageStyle: `
            @media print {
                .print-hide {
                    display: none;
                }
                table th.print-hide,
                table td.print-hide {
                    border: none;
                }
            }
        `,
    }); */

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Invoice",
        onBeforeGetContent: () => {
            // Ensure data is fully ready before printing
            return new Promise((resolve, reject) => {
                if (dataReady) {
                    resolve(); // Continue with printing
                } else {
                    reject();  // Prevent printing if data is not ready
                }
            });
        },
        onAfterPrint: () => {
            setIsPrinted(true);
        },
        pageStyle: `
        @media print {
            .print-hide {
                display: none;
            }
            table th.print-hide,
            table td.print-hide {
                border: none;
            }
        }
    `,
    });

    /*  <ReactToPrint
         trigger={() => (
             <button onClick={handlePrint}>Print</button>
         )}
         content={() => componentRef.current}
         documentTitle="Invoice"
         onAfterPrint={() => {
             alert("PDF downloaded");
             setIsPrinted(true);
         }}
     /> */

    const calculateColumnSum = (fieldName) => {
        if (excludeFromSum(fieldName)) {
            return '';
        }
        const sum = tableData.reduce((accumulator, rowData) => {
            return accumulator + (isNaN(rowData[fieldName]) ? 0 : parseFloat(rowData[fieldName]));
        }, 0);
        return sum.toFixed(2);
    };
    // Function to check if a column should be excluded from sum
    const excludeFromSum = (fieldName) => {
        const excludedColumns = ['Rate', 'GstRate', 'GstAmt', 'NetAmt'];
        const lowerCaseFieldName = fieldName.toLowerCase();
        return excludedColumns.some(excludedColumn => excludedColumn.toLowerCase() === lowerCaseFieldName);
    }

    //console.log("Report Data:", reportData);

    const amtTotal = tableData.reduce((total, rowData) => {
        const amt = parseFloat(rowData.NetAmt);
        return total + (isNaN(amt) ? 0 : amt);
    }, 0).toFixed(2);

    return (
        <div ref={componentRef} style={{
            padding: '12px',
            border: '1px solid black',
            width: '210mm',
            minHeight: '297mm',
            margin: '0 auto',
            fontFamily: 'Arial, sans-serif',
            boxSizing: 'border-box',
        }}>
            {hasTableData ? (
                <div>
                    <div style={{ textAlign: 'center', paddingBottom: '5px', marginBottom: '5px' }}>
                        <h2 style={{ margin: '0', fontSize: '18px' }}>{CompName ? CompName : 'Quik Beverages and Foods Pvt. Ltd.'}</h2>
                        <p style={{ margin: '0', fontSize: '14px' }}>Manufacturers & Exporters of Food Products</p>
                        <p style={{ margin: '0', fontSize: '12px'/* , borderTop:'1px solid #333' */ }}>Gat No 655/2, Pune Bengaluru National Highway, At Post - Nerle,</p>
                        <p style={{ margin: '0', fontSize: '12px'/* , borderBottom:'1px solid #333' */ }}>Taluka - Walwa, District - Sangli, Maharashtra (India)</p>
                        <p style={{ margin: '0', fontSize: '12px' }}>FSSAI NO.: 11521998000122 | Phone: (+91) 2342 278200</p>
                        <p style={{ margin: '0', fontSize: '12px' }}>CIN NO.: U15490PN2014PTC150251</p>
                        <p style={{ margin: '0', fontSize: '12px' }}>www.superbmegacorp.com</p>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', border: '1px solid black', width: '100%', fontSize: '14px' }}>
                        <div style={{ display: 'flex', borderBottom: '1px solid black' }}>
                            <div style={{ flex: 1, padding: '6px', borderRight: '1px solid black', textAlign: 'center' }}>
                                <strong>Billing Address</strong>
                            </div>
                            {CompCode === 2 ? 
                            (<div style={{ flex: 4, padding: '6px' }}>
                                <p style={{ margin: '0' }}><strong>SRI SAIJEET EXPORT PVT. LTD.</strong> </p>
                                <p style={{ margin: '0' }}>Survey No0655/2,NH-4,behind SaiSamrat Food, At Post - Nerle, Taluka - Walwa, District - Sangli</p>
                                <p style={{ margin: '0' }}>Pin 415406, Maharashtra (India)</p>
                            </div>) :
                            (<div style={{ flex: 4, padding: '6px' }}>
                                <p style={{ margin: '0' }}><strong>Quik Beverages and Foods Pvt. Ltd.</strong> </p>
                                <p style={{ margin: '0' }}>Gat No 655/2, Pune Bengaluru National Highway, At Post - Nerle, Taluka - Walwa, District - Sangli</p>
                                <p style={{ margin: '0' }}>Pin 415 406, Maharashtra (India)</p>
                            </div>) 
                            }
                        </div>

                        <div style={{ display: 'flex', borderBottom: '1px solid black' }}>
                            <div style={{ flex: 1, padding: '6px', borderRight: '1px solid black', textAlign: 'center' }}>
                                <strong>Shipping Address</strong>
                            </div>
                            {CompCode === 2 ?
                                (<div style={{ flex: 4, padding: '6px' }}>
                                    <p style={{ margin: '0' }}><strong>SRI SAIJEET EXPORT PVT. LTD.</strong> </p>
                                    <p style={{ margin: '0' }}>Survey No0655/2,NH-4,behind SaiSamrat Food, At Post - Nerle, Taluka - Walwa, District - Sangli</p>
                                    <p style={{ margin: '0' }}>Pin 415406, Maharashtra (India)</p>
                                </div>) :
                                (<div style={{ flex: 4, padding: '6px' }}>
                                    <p style={{ margin: '0' }}><strong>Quik Beverages and Foods Pvt. Ltd.</strong></p>
                                    <p style={{ margin: '0' }}>Plot No. C - 14, MIDC Shirala, Taluka - Shirala, District - Sangli</p>
                                    <p style={{ margin: '0' }}>Pin 415 408, Maharashtra (India)</p>
                                </div>)}
                        </div>

                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: 1, padding: '6px', borderRight: '1px solid black', textAlign: 'center' }}>
                                <strong>Contact Details</strong>
                            </div>
                            <div style={{ flex: 4, padding: '6px' }}>
                                <p style={{ margin: '0' }}>E-mail: ____________________ | Mobile: +91___________</p>
                            </div>
                        </div>
                    </div>

                    <div style={{ border: '1px solid black', width: '100%', fontSize: '14px', marginTop: '10px' }}>
                        <div style={{ textAlign: 'center', padding: '6px', fontWeight: 'bold', borderBottom: '1px solid black' }}>
                            {flag === 'POS' ? 'PURCHASE ORDER' : 'DELIVARY CHALLAN'}
                        </div>

                        <div style={{ display: 'flex', borderBottom: '1px solid black' }}>
                            <div style={{ flex: 1, padding: '6px', borderRight: '1px solid black' }}>
                                <strong>PO. No. :-</strong>
                                <span style={{ marginLeft: '10px' }}>{hasTableData ? tableData[0].PONo : ''}</span>
                            </div>
                            <div style={{ flex: 1, padding: '6px' }}>
                                <strong>Date :-</strong>
                                <span style={{ marginLeft: '10px' }}>{new Date(hasTableData ? tableData[0].TrDate : '').toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</span>
                            </div>
                        </div>

                        <div style={{ display: 'flex', borderBottom: '1px solid black' }}>
                            <div style={{ flex: 1, padding: '6px', borderRight: '1px solid black' }}>
                                <strong>Client Name</strong>
                            </div>
                            <div style={{ flex: 3, padding: '6px' }}>
                                <strong>{AcHead}</strong>
                            </div>
                        </div>

                        <div style={{ display: 'flex' }}>
                            <div style={{ flex: 1, padding: '6px', borderRight: '1px solid black' }}>
                                <strong>Client Address</strong>
                            </div>
                            <div style={{ flex: 3, padding: '6px' }}>
                                <p style={{ margin: '0' }}>{AcAddress1}</p>
                                <p style={{ margin: '0' }}>{AcAddress2}</p>
                            </div>
                        </div>
                    </div>

                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px', fontSize: '14px' }}> {/* Set font size here */}
                        <thead>
                            <tr style={{ backgroundColor: '#E8E8E8' }}>
                                <th style={{ border: '1px solid black', padding: '6px' }}>Sr. No</th>
                                <th style={{ border: '1px solid black', padding: '6px' }}>Product Name</th>
                                {hasTableData && ['Rate', 'Qty', 'Amt', 'GstRate', 'GstAmt', 'NetAmt']
                                    .filter(field => Object.keys(tableData[0]).includes(field))
                                    .map((field) => {
                                        let displayName = field;
                                        if (field === 'GstRate') {
                                            displayName = 'GST(%)';
                                        } else if (field === 'Amt') {
                                            displayName = 'Amount';
                                        } else if (field === 'NetAmt') {
                                            displayName = 'NetAmount';
                                        }
                                        return (
                                            <th key={field} style={{ border: '1px solid black', padding: '6px' }}>
                                                {displayName}
                                            </th>
                                        );
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((rowData, index) => {
                                const selectedGroup = ItemMaster.find(group => group.ItCode == rowData.ItCode);
                                return (
                                    <tr key={index} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                                        <td style={{ padding: '4px', border: '1px solid black' }}>{index + 1}</td>
                                        <td style={{
                                            padding: '4px',
                                            border: '1px solid black',
                                            maxWidth: '200px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {selectedGroup && selectedGroup.ItName ? (
                                                <span>
                                                    {selectedGroup.ItName} :
                                                    <span style={{ fontSize: '10px' }}>
                                                        {rowData.ItemDesc}
                                                    </span>
                                                </span>
                                            ) : ''}
                                        </td>
                                        {hasTableData && ['Rate', 'Qty', 'Amt', 'GstRate', 'GstAmt', 'NetAmt']
                                            .filter(key => rowData.hasOwnProperty(key))
                                            .map((key, colIndex) => (
                                                <td key={colIndex} style={{ padding: '4px', border: '1px solid black', textAlign: 'right' }}>
                                                    {['Rate', 'Amt', 'NetAmt'].includes(key) ?
                                                        (typeof rowData[key] === 'string' ? parseFloat(rowData[key]).toFixed(2) : rowData[key].toFixed(2)) :
                                                        rowData[key]
                                                    }
                                                </td>
                                            ))
                                        }
                                    </tr>
                                );
                            })}
                            <tr style={{ textAlign: 'center' }}>
                                <td style={{ padding: '5px', border: '1px solid black' }} colSpan="1"></td>
                                <td style={{ padding: '5px', border: '1px solid black', fontWeight: 'bold' }}>Sub-Total</td>
                                {hasTableData && ['Rate', 'Qty', 'Amt', 'GstRate', 'GstAmt', 'NetAmt']
                                    .filter(field => Object.keys(tableData[0]).includes(field))
                                    .map((field) => (
                                        <td key={field} style={{ padding: '5px', border: '1px solid black', fontWeight: 'bold', textAlign: 'right' }}>
                                            {calculateColumnSum(field)}
                                        </td>
                                    ))}
                            </tr>
                            <tr>
                                <td style={{ borderBottom: '1px solid black', borderLeft: '1px solid black', padding: '6px', textAlign: 'center' }} colSpan={6}></td>
                                <td style={{ border: '1px solid black', padding: '6px', textAlign: 'center', fontWeight: 'bold' }}>Total</td>
                                <td style={{ border: '1px solid black', padding: '6px', textAlign: 'right', fontWeight: 'bold' }} colSpan={4}>{amtTotal}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div style={{ borderBottom: '1px solid black', marginBottom: '15px', marginTop:'12px', fontSize: '14px' }}>
                        {/* <p><strong>Doc. No.</strong>: QUIK TEA-004/Rev.No.001/Issue Date.1 SEP2020</p> */}
                    </div>

                    {/* <div style={{ marginBottom: '5px', borderBottom: '1px solid black', fontSize: '12px' }}>
                        {tableData[0] && (
                            <div>
                                {tableData[0].Narration1 && <p>1. {tableData[0].Narration1}</p>}
                                {tableData[0].Narration2 && <p>2. {tableData[0].Narration2}</p>}
                                {tableData[0].Narration3 && <p>3. {tableData[0].Narration3}</p>}
                                {tableData[0].Narration4 && <p>4. {tableData[0].Narration4}</p>}
                            </div>
                        )}
                    </div> */}

                    <div style={{ marginBottom: '5px', marginTop:'12px', borderBottom: '1px solid black', fontSize: '14px' }}>
                        <p>1. Please send two copies of your invoice. Invoice to be made in the name of {CompName} Foods Pvt Ltd.</p>
                        <p>2. Enter this order in accordance with the prices, terms, delivery method, and specifications listed above.</p>
                        <p>3. Please notify us immediately if you are unable to ship as specified.</p>
                        <p>4. Payment Terms: 30 days credit.</p>
                        <p>5. Send all correspondence to: _________________________</p>
                        {tableData[0].Narration1 && <p>6. {tableData[0].Narration1}</p>}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid black', marginBottom: '15px', marginTop:'12px', fontSize: '14px' }}>
                        <strong>For {CompName ? CompName : 'Quik Beverages and Foods Pvt. Ltd.'}</strong>
                    </div>
                    <div style={{ paddingTop: '60px', width: '100%' }}>
                        <div style={{ display:/*  */'flex', borderTop: '1px solid #333', borderBottom: '1px solid #333' }}>
                            <div style={{ width: '40%', borderRight: '1px solid #333', padding: '5px' }}>Director</div>
                            <div style={{ padding: '5px' }}>Verified By</div>
                        </div>
                    </div>
                    <button className="print-hide" onClick={handlePrint}>Generate PDF</button>
                </div>
            ) : (
                <p>Loading data...</p>
            )}
        </div>
    );
};

export default Invoice;





























































































